import { Routes } from '@angular/router';
import { screensViewRoute } from './view/screens-view.route';

const SCREENS_INTERVIEW_ROUTES = [screensViewRoute];

export const screensInterviewState: Routes = [
    {
        path: 'mras/interview',
        children: SCREENS_INTERVIEW_ROUTES,
        data: {
            authorities: []
        }
    }
];
